import { useLazyQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import VisibilityIcon from '@mui/icons-material/Visibility';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CircleIcon from '@mui/icons-material/Circle';

import { CustomChip } from '../../../../components/chip/Chip';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';

import GET_REMITOS_BNP, { adaptRemitosBNPArray } from '../../../../data/graphQL/queries/GestionAsistencial/getRemitosBNPByIdEvaluacion';
import GET_REMITO_BNP_DETALLE, { adaptRemitoBNPDetalleArray } from '../../../../data/graphQL/queries/GestionAsistencial/getRemitoBNPDetalle';
import GET_REMITO_BNP_DOCUMENTO, { adaptRemitoBNPArchivo } from '../../../../data/graphQL/queries/GestionAsistencial/getRemitosBNPDocumento';
import DocumentViewer from '../../../../components/DocumentViewer';

export const TabRemitosBNP = ({ idEvaluacionSelected }) => {

  const [remitos, setRemitos] = useState([]);
  const [remito, setRemito] = useState([]);
  const [documento, setDocumento] = useState('');
  const [openDlgView, setOpenDlgView] = useState(false);

  const leyendaCantBolsas = <span><strong>Cantidad de Bolsas:</strong>&nbsp;&nbsp;{remitos?.length}</span>;
  const [cantBolsas, setCantBolsas] = useState(leyendaCantBolsas);

  const [getRemitos, { data: dataRemitos, loading: getRemitosLoading }] = useLazyQuery(GET_REMITOS_BNP, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRemitos) return;
    setRemitos(adaptRemitosBNPArray(dataRemitos.remitosBNP.valorEsperado));
    setRemito([]);
  }, [dataRemitos]);

  const [getRemitoDetalle, { data: dataRemitoDetalle, loading: getRemitoDetalleLoading }] = useLazyQuery(GET_REMITO_BNP_DETALLE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRemitoDetalle) return;
    setRemito(adaptRemitoBNPDetalleArray(dataRemitoDetalle.remitoBNPDetalle.valorEsperado));
  }, [dataRemitoDetalle]);

  const [getArchivoRemito, { data: dataArchivoRemito, loading: getArchivoRemitoLoading }] = useLazyQuery(GET_REMITO_BNP_DOCUMENTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataArchivoRemito) return;
    setDocumento(adaptRemitoBNPArchivo(dataArchivoRemito.archivoRemitoBNP.valorEsperado));
    setOpenDlgView(true);
  }, [dataArchivoRemito]);

  useEffect(() => {
    setCantBolsas(leyendaCantBolsas);
  }, [remitos]);

  useEffect(() => {
    if (!idEvaluacionSelected) return;
    getRemitos({ variables: { idEvaluacion: idEvaluacionSelected } });
  }, [idEvaluacionSelected]);

  const verRemitoDetalle = (remito) => {
    getRemitoDetalle({ variables: { idRemito: remito.idRemito } });
  };

  const verAdjuntoDetalle = (remito) => {
    getArchivoRemito({ variables: { numeroRemito: remito.numeroRemito } });
  };

  const initialColumns = [
    {
      headerName: '',
      minWidth: 26,
      maxWidth: 26,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <VisibilityIcon
            className='edit-icon'
            onClick={() => verRemitoDetalle(row)}
            sx={{ fontSize: '12pt', margin: '0', padding: '0', paddingBottom: '4px' }} />);


      }
    },
    {
      minWidth: 58,
      field: 'idRemito',
      headerName: '#'
    },
    {
      minWidth: 77,
      field: 'fecha',
      type: 'date',
      headerName: 'Fecha'
    },
    {
      minWidth: 60,
      field: 'origen',
      headerName: 'Origen'
    },
    {
      minWidth: 110,
      field: 'numeroRemito',
      headerName: 'Número remito'
    },
    {
      minWidth: 68,
      field: 'tieneDocumento',
      headerName: 'Remito',
      align: 'center',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            {
              row.tieneDocumento == 1 &&
              <AttachFileIcon
                className='edit-icon'
                onClick={() => verAdjuntoDetalle(row)}
                sx={{ fontSize: '13pt', paddingBottom: '5px' }} />

            }
            {
              row.tieneDocumento != 1 &&
              <CircleIcon
                className='edit-icon'
                sx={{ fontSize: '7pt', paddingBottom: '6px', cursor: 'default' }} />

            }
          </>);

      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [remitos]);

  const initialColumnsDetalle = [
    {
      minWidth: 58,
      maxWidth: 58,
      field: 'idRemito',
      headerName: '#'
    },
    {
      minWidth: 110,
      maxWidth: 110,
      field: 'codigo',
      headerName: 'Código'
    },
    {
      minWidth: 200,
      field: 'descripcion',
      headerName: 'Descripción'
    },
    {
      minWidth: 75,
      maxWidth: 75,
      field: 'cantidad',
      headerName: 'Cantidad'
    },
    {
      minWidth: 110,
      maxWidth: 110,
      field: 'volumenBolsa',
      headerName: 'Volumen Bolsa'
    }];


  const columnsDetalle = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsDetalle), [remitos]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ md: 5, xs: 12 }}>
          <div className='generic-tab-container'>
            <div style={{ display: 'flex' }}>
              <div><strong>Remitos</strong></div>
              <div style={{ marginLeft: '20px' }}><CustomChip label={cantBolsas} /></div>
            </div>
            <br />
            <DataGridGenerico
              columns={columns}
              rows={remitos}
              toolbar={false}
              loading={getRemitosLoading}
              hideFooter
              autoHeight>

            </DataGridGenerico>
          </div>
        </Grid>
        <Grid size={{ md: 7, xs: 12 }}>
          <div className='generic-tab-container'>
            <strong>Detalles</strong>
            <br /><br />
            <DataGridGenerico
              columns={columnsDetalle}
              rows={remito}
              toolbar={false}
              loading={getRemitoDetalleLoading}
              hideFooter
              autoHeight>

            </DataGridGenerico>
          </div>
        </Grid>
      </Grid>
      {!!documento?.titulo && openDlgView && <DocumentViewer data={documento} setOpenDlg={setOpenDlgView} download={true} />}
    </>);


};